'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _behaviours = require('./behaviours');

var _behaviours2 = _interopRequireDefault(_behaviours);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapAddressBook = function wrapAddressBook(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(WrappedComponent, (0, _behaviours2.default)(props));
  };
};

exports.default = function (WrappedComponent) {
  return (0, _reactRedux.connect)(function (_ref) {
    var addressBook = _ref.addressBook,
        user = _ref.user,
        presentation = _ref.presentation;
    return {
      addressBook: addressBook,
      user: user,
      addressBookVisible: presentation.addressBookVisible,
      addressBookPage: presentation.addressBookPage,
      addressBookType: presentation.addressBookType,
      addressBookEditId: presentation.addressBookEditId,
      selectedAddressIds: presentation.selectedAddressIds
    };
  })(wrapAddressBook(WrappedComponent));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/higherOrder/addressBook/index.js
// module id = 2341
// module chunks = 0